export const anatomyKeys = {
  status: () => ['anatomy', 'status'] as const,
  dashboard: () => ['anatomy', 'dashboard'] as const,
  settings: () => ['anatomy', 'settings'] as const,
  followUpTypes: () => ['anatomy', 'follow-up-types'] as const,
  followUpHistory: (take: number) => ['anatomy', 'follow-up-history', take] as const,
  meetings: () => ['anatomy', 'meetings'] as const,
  meetingsFiltered: (f: object) => ['anatomy', 'meetings', 'filtered', f] as const,
  registrationHistory: (take: number) => ['anatomy', 'registration-history', take] as const,
  memberSearch: (term: string) => ['anatomy', 'member-search', term] as const,
  memberLink: (memberId: number) => ['anatomy', 'member-link', memberId] as const,
  logs: (f: { function?: string; failuresOnly?: boolean; take?: number }) => ['anatomy', 'logs', f] as const,
};
